module.exports = "<section class=\"quote\"><div class=\"quote-wrap col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-2\"><span class=\"quotemark\"><img src=\"../../assets/img/quotemark.svg\"/></span><p class=\"quote\" [innerHTML]=\"quote | safeHtml\"></p><span class=\"line\">-</span><p class=\"quote-by\" [innerHTML]=\"quoteBy | safeHtml\"></p></div></section>"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/quote/quote.component.html
// module id = ../../../../../src/app/quote/quote.component.html
// module chunks = main